import TinyEmitter from 'tiny-emitter';

export const eventBus = new TinyEmitter();

// You can add your custom methods as needed
eventBus.deferredEmit = (eventName, ...args) => {
  setTimeout(() => eventBus.emit(eventName, args), 0);
};